import React from "react";
import { AxiosError } from "axios";
import { MakeRequest } from "./DataUtil";
import { createStore, getStore, setStore } from "./Stores";

interface StoreProps {
  data: [];
}

const getStoreData = async (storeName: string, uri: string): Promise<any> => {
  const successCallback = (result: any): void => {
    if (result && result.Success) {
      createStore(storeName);
      setStore(result.Data, storeName);
    }
  };
  const errorCallback = (error: AxiosError): void => {
    if (error) {
      console.log(error.response ? error.message : "Unknown Error");
    }
  };
  MakeRequest({
    url: uri,
    method: "get",
    data: {},
    successCallback,
    errorCallback,
  });
};

//create stores
export const loadStores = async (props: StoreProps): Promise<any> => {
  if (props && props !== undefined && props.data && props.data !== undefined) {
    props.data.forEach((store: any, index: number) => {
      //do we have a store already?
      let storeData: any[] = getStore(store.storeName);
      if (
        storeData === null ||
        storeData === undefined ||
        storeData.length === 0
      ) {
        //get store from API
        getStoreData(store.storeName, store.uri);
      }
    });
  }
};
